import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from 'app/app.component';
import { fuseConfig } from 'app/fuse-config';
import { MatDialogModule } from '@angular/material/dialog';
import 'hammerjs';
import { CookieService } from 'ngx-cookie-service';
import { AngularMaterialModule } from './angular-material.module';
import { AppRoutingModule, routing } from './app-routing.module';
import { AdminViewModule } from './modules/admin-view/admin-view.module';
import { SidebarTreeService } from './modules/agenda-view/services/sidebar-tree.service';
import { AuthModule } from './modules/auth/auth.module';
import { CalanderFullService } from './modules/Calander/services/calander-full.service';
import { JwtInterceptor } from './modules/common/helpers/Jwt.Interceptor';
import { SharedService } from './modules/common/services/shared-service';
import { SharedModule } from './modules/common/shared.module';
import { DoctorsViewModule } from './modules/doctors-view/doctors-view.module';
import { EmployeeViewModule } from './modules/employee-view/employee-view.module';
import { EmployeeModule } from './modules/employee/employee.module';
import { FuseShortcutsModule } from './modules/fuse/components/shortcuts/shortcuts.module';
import { HeaderService } from './modules/fuse/services/header-service';
import { LayoutModule } from './modules/layout/layout.module';
import { LeaveModule } from './modules/leave/leave.module';
import { MaintenanceModule } from './modules/maintenance/maintenance.module';
import { EstudioReportsComponent } from './modules/reports/components/estudio-report-view/reports-view/estudio-reports/estudio-reports.component';
import { SelectionGenericModule } from './modules/selection-generic/selection-generic.module';
import { TaskModule } from './modules/task/task.module';
import { AuthGuard } from './_guards/auth.guard';
import { RoleGuard } from './_guards/role.guard'; 

import { AttributeExcelPanelComponent } from './modules/attribute-import/attribute-excel-panel/attribute-excel-panel.component';
import { AttributeImportComponent } from './modules/attribute-import/attribute-import.component';
import { AttributeParameterComponent } from './modules/attribute-import/attribute-parameter/attribute-parameter.component';
import { UserManagementModule } from './modules/users/user-management.module';

import { CompanyViewModule } from './modules/company-view/company-view-module';
import { ConveniosAddEditComponent } from './modules/convenios/convenios-detail/convenios-add-edit/convenios-add-edit.component';
import { ConveniosDetailComponent } from './modules/convenios/convenios-detail/convenios-detail.component';
import { AddConveniosComponent } from './modules/convenios/convenios-list/add-convenios/add-convenios.component';
import { ConveniosListComponent } from './modules/convenios/convenios-list/convenios-list.component';
import { ConveniosComponent } from './modules/convenios/convenios.component';
import { AsistentesPopupComponent } from './modules/coordinator/components/coordinator-company/asistentes-popup/asistentes-popup.component';
import { CoordinatorModule } from './modules/coordinator/coordinator.module';
import { CoordinatorsDetailComponent } from './modules/coordinators/coordinators-detail/coordinators-detail.component';
import { CoordinatorAddEditComponent } from './modules/coordinators/coordinators-detail/popups/coordinator-add-edit/coordinator-add-edit.component';
import { CoordinatorsListComponent } from './modules/coordinators/coordinators-list/coordinators-list.component';
import { CoordinatorAddListComponent } from './modules/coordinators/coordinators-list/popups/coordinator-add-list/coordinator-add-list.component';
import { CoordinatorsComponent } from './modules/coordinators/coordinators.component';
import { DeletedLeavesComponent } from './modules/deleted-leaves/deleted-leaves.component';
import { AddCalanderComponent } from './modules/labor-view/holiday-list/add-calander/add-calander.component';
import { HolidayListComponent } from './modules/labor-view/holiday-list/holiday-list.component';
import { LaborViewComponent } from './modules/labor-view/labor-view.component';
import { VacationAddComponent } from './modules/labor-view/vacation-list/vacation-add/vacation-add.component';
import { VacationListComponent } from './modules/labor-view/vacation-list/vacation-list.component';
import { LeaveImportExcelComponent } from './modules/leave-import/leave-import-excel/leave-import-excel.component';
import { LeaveImportParameterComponent } from './modules/leave-import/leave-import-parameter/leave-import-parameter.component';
import { LeaveImportComponent } from './modules/leave-import/leave-import.component';
import { CriteriosComponent } from './modules/leave-import/popups/criterios/criterios.component';
import { NewRuleDialogComponent } from './modules/leave-import/popups/new-rule-dialog/new-rule-dialog.component';
import { MonthlyExpensesModule } from './modules/monthly-expenses/monthly-expenses.module';
import { PopupViewComponent } from './modules/reports/components/estudio-report-view/popup-view/popup-view.component';
import { SaveLeaveReportNameComponent } from './modules/reports/components/leave-report-view/leave-report-panels/save-leave-report-name/save-leave-report-name.component';
import { ImportarEmpresaModalComponent } from './modules/staff-count/staff-import-view/popups/importar-empresa-modal/importar-empresa-modal.component';
import { DocumentViewContainerComponent } from './modules/employee-view/documentos/document-view-container/document-view-container.component';
import { GruposEmpresaModule } from './modules/grupos-empresa/grupos-empresa.module';

import { MatTabsModule } from '@angular/material/tabs';
//import { CoordinatorsComponent } from './modules/coordinators/coordinators.component';
import { DespachoColaboradoresComponent } from './modules/despacho-colaboradores/despacho-colaboradores.component';
import { DespachoCoordinadoresComponent } from './modules/despacho-coordinadores/despacho-coordinadores.component';
import { VisitasEmpresaComponent } from './modules/visitas-empresa/visitas-empresa.component';
import { CoordinadoreMainComponent } from './modules/coordinadore-main/coordinadore.main.component';
import { DespachoColaboradoresReportPopupComponent } from './modules/despacho-colaboradores/popups/despacho-colaboradores-report-popup/despacho-colaboradores-report-popup.component';
import { DespachoCoordinadoresReportPopupComponent } from './modules/despacho-coordinadores/popups/despacho-coordinadores-report-popup/despacho-coordinadores-report-popup.component';
import { VisitasEmpresaReportPopupComponent } from './modules/visitas-empresa/popups/visitas-empresa-report-popup/visitas-empresa-report-popup.component';



export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({ declarations: [
        AppComponent,
        AttributeImportComponent,
        AttributeParameterComponent,
        AttributeExcelPanelComponent,
        DocumentViewContainerComponent,
        LeaveImportComponent,
        LeaveImportParameterComponent,
        LeaveImportExcelComponent,
        CriteriosComponent,
        CoordinatorsComponent,
        CoordinatorsListComponent,
        CoordinatorsDetailComponent,
        CoordinatorAddEditComponent,
        CoordinatorAddListComponent,
        ConveniosComponent,
        ConveniosListComponent,
        ConveniosDetailComponent,
        ConveniosAddEditComponent,
        AddConveniosComponent,
        LaborViewComponent,
        HolidayListComponent,
        AddCalanderComponent,
        VacationListComponent,
        VacationAddComponent,
        DeletedLeavesComponent,
        CoordinatorAddListComponent,
        NewRuleDialogComponent,
        DespachoColaboradoresComponent,
        DespachoColaboradoresReportPopupComponent,
        DespachoCoordinadoresComponent,
        DespachoCoordinadoresReportPopupComponent,
        VisitasEmpresaComponent,
        VisitasEmpresaReportPopupComponent,
        CoordinadoreMainComponent,

    ],
    exports: [
        BrowserAnimationsModule,
        HttpClientModule,
        FuseShortcutsModule
    ],
    bootstrap: [
        AppComponent
    ], imports: [BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        TranslateModule.forRoot(),
        BrowserAnimationsModule,
        FormsModule,
        routing,
        FontAwesomeModule,
        AngularMaterialModule,
        MatDialogModule,
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        // App modules
        LayoutModule,
        DoctorsViewModule,
        //AgendaViewModule,
        //AuthenticationModule,
        //TaskSelectionViewModule,
        //EmployeeViewModule,
        MaintenanceModule,
        TaskModule,
        EmployeeModule,
        LeaveModule,
        //DoctorModule,
        SharedModule,
        SelectionGenericModule,
        AuthModule,
        AdminViewModule,
        //DoctorBillingModule,
        //StaffCountModule,
        //ReportsModule,
        //DebugViewModule,
        UserManagementModule,
        MonthlyExpensesModule,
        CoordinatorModule,
        CompanyViewModule,
        //AdministrativesModule,
        MatTabsModule,

    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        SidebarTreeService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'en-US' },
        CalanderFullService,
        SharedService,
        HeaderService,
        AuthGuard,
        RoleGuard,
        CookieService,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
        GruposEmpresaModule
    ] })
export class AppModule {
}
